module.exports = __webpack_public_path__ + "static/media/conservativefund.f1f56c72.jpg";